import { debug } from '../../utils/debug'
import type { SetAppError } from '../types/actions'
import { APP_STATUS } from '../types/enums'

import { actionFactory } from './factory'

export const setAppError = actionFactory<SetAppError>(
  (state, { error, reason }) => {
    state.appStatus = APP_STATUS.FAILED
    state.appError = error

    // logs out for debugging purposes
    if (reason) {
      debug('Editor failed:', reason)
    }
  },
  'setAppError'
)
